import React, { FC } from 'react';
import { styled } from 'linaria/react';
import range from 'lodash.range';

const Container = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	padding: 32px 0;
	margin-top: auto;
`;
const Item = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	background: white;
	border-left: 1px solid var(--gray200);
	cursor: pointer;
	transition: .2s ease-in-out;
	
	&:hover {
		background: var(--gray100);
	}
	
	&:first-child {
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		border-left: none;
	}
	
	&:last-child {
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
	}
	
	&[data-active='true'] {
		pointer-events: none;
		position: relative;
		color: white;
		background: var(--blue500);
	}
`;

export type PaginationMetadata = {
	page: number;
	total: number;
}

type PaginationProps = PaginationMetadata & {
	onPaginated: (page: number) => void;
}

export const Pagination: FC<PaginationProps> = (props) => {
	const { page, total, onPaginated } = props;

	return (
		<Container>
			{range(0, total).map(item => (
				<Item
					key={item}
					data-active={item === page}
					onClick={() => onPaginated(item)}
				>
					{item + 1}
				</Item>
			))}
		</Container>
	);
};
